var map = {
	"./epa.svg": 907,
	"./lbrn.png": 285,
	"./nih.png": 178,
	"./nsf.svg": 494,
	"./original/NSF_logo.svg": 610,
	"./original/epa.svg": 829,
	"./original/lbrn.jpg": 589,
	"./original/nih.png": 786,
	"./vinnova.svg": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;